import { types } from 'mobx-state-tree'

export const UserLevel = types.model('UserLevel').props({
  icon: types.maybeNull(types.string),
  label: types.string,
  min_points: types.number,
  id: types.number,
  level: types.number,
})
